import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/layouts/default/main.vue"
import modules from "./module/index.js"

Vue.use(VueRouter)

const routes = [{
    path: "*",
    redirect: "/404"
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login")
  },
  {
    path: "/",
    redirect: "/dashboard"
  },
  {
    name: 'misc',
    path: "/404",
    component: Layout,
    children: [{
      path: "/404",
      name: "404",
      component: () => import("../views/404")
    }]
  },
  ...modules
]


const router = new VueRouter({
  routes
})

export default router